import __vue_component__ from '../HseBadge/HseBadgeLabel.vue.js';

//

/**
 * @figma https://www.figma.com/file/cBHD57QcCt9WDT4e7e2B3w/hse_general_library?node-id=326%3A0
 * @storybook /?path=/story/tabs-tabs--playground
 * @react /src-components-tabs
 * @reactStorybook /?path=/story/tabs-tabs--playground
 */
var script = {
  name: 'HseTabs',
  components: {
    HseBadgeLabel: __vue_component__
  },
  model: {
    event: 'change',
    prop: 'selected'
  },
  props: {
    /**
     * Массив табов
     */
    tabs: {
      type: Array,
      default: () => []
    },
    /**
     * `value` выбранного таба
     */
    selected: {
      type: String,
      default: ''
    },
    /**
     * Вариант отображения
     * @values line, square, round
     */
    variant: {
      type: String,
      validator: v => ['line', 'square', 'round'].includes(v),
      default: 'line'
    },
    /**
     * Стиль заливки
     * @values outlined, filled, normal
     */
    tabStyle: {
      type: String,
      validator: (val) => ['outlined', 'filled', 'normal'].includes(val),
      default: 'normal'
    },
    /**
     * Дополнительные классы элементов:
     * - item – класс таба
     * - itemCounter – класс счетчика у таба
     * @type {{
     *   item?: string;
        itemCounter?: string;
     * }}
     */
    classes: {
      type: Object,
      default: () => ({
        item: '',
        itemCounter: ''
      })
    }
  },
  data: () => ({
    hoveredItem: null,
    focusedItem: null
  }),
  methods: {
    onClick(tab) {
      if (!tab.disabled) {
        /**
         * Срабатывает при изменении текущего таба
         * @type {any}
         */
        this.$emit('change', tab.value);
      }
    }
  }
};

export default script;
